export default {
	methods: {
		$_createPopoverBBox({ top = 0, left = 0, bottom = 0, height = 0, width = 0, popoverHeight = 0 }) {
			if (popoverHeight === 0 && this.$refs.popover && this.$refs.popover.$el) {
				popoverHeight = this.$refs.popover.$el.getBoundingClientRect().height;
			}

			let calculatedWidth = this.$_calculateWidth(width);
			let calculatedHeight = this.$_calculateHeight(popoverHeight);

			return {
				width: 'auto',
				minWidth: `${calculatedWidth}px`,
				height: 'auto',
				minHeight: this.minHeight,
				top: `${this.$_calculateTop(top, bottom, height, calculatedHeight)}px`,
				left: `${this.$_calculateLeft(left, calculatedWidth)}px`,
			};
		},
		$_calculateWidth(desiredWidth) {
			return Math.max(this.width, this.minWidth, desiredWidth);
		},
		$_calculateHeight(desiredHeight) {
			return Math.max(this.height, this.minHeight, desiredHeight);
		},
		$_calculateTop(targetTop, targetBottom, targetHeight, popoverHeight) {
			let isOverflowingBottom = this.$_isOverflowingY(targetBottom, popoverHeight);
			if (isOverflowingBottom) {
				let positionTopTarget = targetTop - this.marginY - popoverHeight;
				if (positionTopTarget < 0) {
					return this.marginY;
				} else {
					return positionTopTarget;
				}
			} else {
				return targetBottom + this.marginY;
			}
		},
		$_isOverflowingY(y, height, isBottom = true) {
			let minTop = window.pageYOffset || document.documentElement.scrollTop;
			let maxTop = minTop + window.innerHeight - this.marginY;
			let overflowTop = ((y - height - this.marginY) < minTop);
			let overflowBottom = ((y + height + this.marginY) > maxTop);

			return isBottom ? overflowBottom : overflowTop;
		},
		$_calculateLeft(desiredLeft, width) {
			let minLeft = window.pageXOffset || document.documentElement.scrollLeft;
			let maxLeft = minLeft + window.innerWidth - width - this.marginX;
			if (desiredLeft > maxLeft) {
				return maxLeft;
			} else if (minLeft > desiredLeft) {
				return minLeft;
			} else {
				return desiredLeft;
			}
		},
	}
};